import { render } from "./collapse.vue?vue&type=template&id=af60a4a2&scoped=true"
import script from "./collapse.vue?vue&type=script&lang=js"
export * from "./collapse.vue?vue&type=script&lang=js"

import "./collapse.vue?vue&type=style&index=0&id=af60a4a2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-af60a4a2"

export default script